import React from "react";
import Flex from "../Generic/Flex";
import { CaregiverStaffingPreferenceTypes } from "../../messages";
import "./MystaffingPreferences.scss";
import { AppInput } from "../Generic/AppInput";
import { AppBottomSheet } from "../Generic/AppBottomSheet";
import { AppOverlay } from "../Generic/AppOverlay";
import { SEND_MESSAGE_SVG } from "../../utils/svgs";
import { AppIcon } from "../Generic/AppIcon";
import { PencilSquareIcon } from "../../utils/icones";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";

interface StaffingPreferenceTextProps {
  label: string;
  type: CaregiverStaffingPreferenceTypes;
  value: string | null;
  onChange: (preference: CaregiverStaffingPreferenceTypes, value: string | null) => void;
}

const StaffingPreferenceText = (props: StaffingPreferenceTextProps) => {
  const [isTextModalOpen, setIsTextModalOpen] = React.useState(false);

  return (
    <Flex direction="column" gap={20}>
      <div className="MyStaffingPreferences__QuestionLabel"> {props.label} </div>
      <Flex
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        onClick={() => setIsTextModalOpen(true)}
      >
        <div className="MyStaffingPreferences__TextQuestionAnswerEdit">
          <PencilSquareIcon />
        </div>
        <div className="MyStaffingPreferences__Answer">
          {props.value === null || props.value === "" ? translate(STRINGS.NOT_SET) : props.value}
        </div>
      </Flex>
      <TextAnswerPopup
        isOpen={isTextModalOpen}
        value={props.value}
        onClose={() => setIsTextModalOpen(false)}
        onChange={(value: string | null) => props.onChange(props.type, value)}
      />
    </Flex>
  );
};

export default StaffingPreferenceText;

const TextAnswerPopup = (props: {
  isOpen: boolean;
  value: string | null;
  onClose: () => void;
  onChange: (value: string | null) => void;
}) => {
  const [value, setValue] = React.useState<string | null>(props.value);

  const handleChangeValueClick = (value: string | null) => {
    props.onChange(value);
    props.onClose();
  };

  return (
    <AppOverlay>
      <AppBottomSheet
        isOpen={props.isOpen}
        onRequestClose={props.onClose}
        className="MyStaffingPreferences__TextQuestionAnswerInputContainer"
      >
        <Flex direction="column" gap={10}>
          <div>Change your answer</div>
          <Flex direction="row" justifyContent="space-between" alignItems="center" gap={0}>
            <AppInput
              className="MyStaffingPreferences__TextQuestionAnswerInput"
              value={value ?? ""}
              onChange={(e) => setValue(e.target.value)}
            ></AppInput>
            <AppIcon
              className="MyStaffingPreferences__TextQuestionAnswerInputButton"
              icon={SEND_MESSAGE_SVG}
              onClick={() => handleChangeValueClick(value)}
            />
          </Flex>
        </Flex>
      </AppBottomSheet>
    </AppOverlay>
  );
};
